import styled from '@emotion/styled';
import { Link } from '@reach/router';
import { BANNER_HEIGHT, COLORS, FOOTER_HEIGHT, HEADER_HEIGHT, NAVBAR_HEIGHT } from '../../constants';

export const StyledInaccessibleWrapper = styled.div<{ withBanner?: boolean }>`
  background-color: rgba(223, 223, 223, 0.32);
  height: calc(
    100vh - ${({ withBanner }) => HEADER_HEIGHT + NAVBAR_HEIGHT + FOOTER_HEIGHT + (withBanner ? BANNER_HEIGHT : 0)}px
  );
`;

export const StyledInaccessible = styled.div<{ height: string }>`
  padding: 39px 10px 0px 10px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  height: ${({ height }) => height};
`;

export const StyledInaccessibleContent = styled.div<{ width: string }>`
  width: ${({ width }) => width};
  font-size: 17px;
  font-weight: normal;
  line-height: 1.59;
`;

export const StyledInaccessibleHeader = styled.h1<{ margin?: string }>`
  height: 32px;
  color: ${COLORS.blackOlive};
  font-size: 24px;
  font-weight: 600;
  ${({ margin }) => margin && `margin: ${margin};`};
`;

export const StyledInaccessibleImage = styled.img<{
  height: string;
  margin?: string;
}>`
  height: ${({ height }) => height};
  ${({ margin }) => margin && `margin: ${margin};`}
`;

export const StyledInaccessibleTextLink = styled(Link)`
  text-decoration: underline !important;
  color: ${COLORS.blackOlive};

  cursor: pointer;

  &:focus {
    outline-offset: 3px !important;
    outline: 2px dotted ${COLORS.blueCola} !important;
  }
`;
